import React from 'react'
import InteractiveFormPreview from './InteractiveFormPreview'

interface IProps {
  closeModal: () => void
  formJson: any
  cardBackground: any
  cardStyle: any
  embedded?: boolean
  isPrefillForm?: boolean
}

const PreviewModal: React.FC<IProps> = ({
  formJson,
  cardBackground,
  cardStyle,
  embedded = false,
  isPrefillForm = formJson?.isPrefillForm === true
}) => {
  return (
    <div className={embedded ? 'preview-modal-embedded w-100' : 'container mt-8'}>
      {!embedded && (
        <div className='card-title justify-content-center align-center w-100'>
          <div className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'>
            <div className='d-flex flex-center flex-column flex-column-fluid p-6 pb-lg-20'>
              <InteractiveFormPreview
                formData={formJson}
                cardBackground={cardBackground}
                cardStyle={cardStyle}
                isPrefillForm={isPrefillForm}
              />
              <p className='interactive-form-preview__preview-note mt-3 mb-0'>
                Preview mode — submissions are not saved.
              </p>
            </div>
          </div>
        </div>
      )}
      {embedded && (
        <>
          <InteractiveFormPreview
            formData={formJson}
            cardBackground={cardBackground}
            cardStyle={cardStyle}
            isPrefillForm={isPrefillForm}
          />
          <p className='interactive-form-preview__preview-note mt-3 mb-0'>
            Preview mode — submissions are not saved.
          </p>
        </>
      )}
    </div>
  )
}

export default PreviewModal
